import { useState } from 'react';

export default function TestimonialsSection() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: 'Bukola Lukan',
      position: 'CEO, Ask Roxanne Errands',
      company: 'Online Food and Groceries store',
      image: 'https://static.readdy.ai/image/d841215d0ca23002ee5da92e181f5e13/3e621d99d47c496eeb9b01aa6ec076f2.png',
      text: 'Anietie transformed our brand identity completely. His attention to detail and creative vision exceeded our expectations. The new design has significantly improved our market presence.',
      rating: 5
    },
    {
      id: 2,
      name: 'Ask Roxanne Errands',
      position: 'Online Food and Groceries store',
      company: 'GreenLeaf Organics',
      image: 'https://static.readdy.ai/image/d841215d0ca23002ee5da92e181f5e13/a310e1a2071d2db37a89e84f78576f1d.png',
      text: 'Working with Anietie was a game-changer for our packaging design. He understood our sustainability values and created designs that perfectly represent our brand ethos.',
      rating: 5
    },
    {
      id: 3,
      name: 'Emily Rodriguez',
      position: 'Founder',
      company: 'Bella Boutique',
      image: 'https://public.readdy.ai/ai/img_res/9e73117e97feb2374339f57fbdd39420.jpg',
      text: 'Anietie\'s UI/UX design for our e-commerce platform increased our conversion rate by 40%. His user-centered approach made shopping intuitive and enjoyable for our customers.',
      rating: 5
    },
    {
      id: 4,
      name: 'David Thompson',
      position: 'Event Manager',
      company: 'Elite Events',
      image: 'https://readdy.ai/api/search-image?query=Professional%20businessman%20event%20manager%20portrait%2C%20confident%20male%20professional%20in%20formal%20business%20attire%2C%20corporate%20headshot%20with%20sophisticated%20lighting&width=100&height=100&seq=testimonial-4&orientation=squarish',
      text: 'The promotional materials Anietie designed for our corporate events were outstanding. His creativity and professionalism made our events stand out in the industry.',
      rating: 5
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h4 className="text-yellow-400 font-semibold text-lg mb-4">
            <a href="#testimonials" className="hover:text-yellow-300 transition-colors">Client Feedback</a>
          </h4>
          <h3 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            What Clients <span className="text-yellow-400">Say</span>
          </h3>
          <p className="text-gray-300 text-lg max-w-3xl mx-auto">
            Don't just take my word for it. Here's what my clients have to say about working with me.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-gray-900 rounded-2xl p-8 md:p-12 border border-gray-800 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-20 h-20 bg-yellow-400/10 rounded-full -translate-x-10 -translate-y-10"></div>
            <div className="absolute bottom-0 right-0 w-32 h-32 bg-yellow-400/5 rounded-full translate-x-16 translate-y-16"></div>
            
            <div className="relative z-10">
              <div className="flex items-center justify-center mb-8">
                <div className="flex space-x-1">
                  {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                  ))}
                </div>
              </div>
              
              <blockquote className="text-center mb-8">
                <p className="text-xl md:text-2xl text-gray-300 leading-relaxed italic">
                  "{testimonials[currentTestimonial].text}"
                </p>
              </blockquote>
              
              <div className="flex items-center justify-center space-x-4">
                <img
                  src={testimonials[currentTestimonial].image}
                  alt={testimonials[currentTestimonial].name}
                  className="w-16 h-16 rounded-full object-cover border-2 border-yellow-400"
                />
                <div className="text-center">
                  <h5 className="text-white font-semibold text-lg">
                    {testimonials[currentTestimonial].name}
                  </h5>
                  <p className="text-gray-400 text-sm">
                    {testimonials[currentTestimonial].position}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex items-center justify-center space-x-4 mt-8">
            <button
              onClick={prevTestimonial}
              className="w-12 h-12 flex items-center justify-center bg-gray-800 hover:bg-yellow-400 text-white hover:text-black rounded-full transition-all duration-300 cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </button>
            
            <div className="flex space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTestimonial(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                    index === currentTestimonial ? 'bg-yellow-400' : 'bg-gray-600 hover:bg-gray-500'
                  }`}
                ></button>
              ))}
            </div>
            
            <button
              onClick={nextTestimonial}
              className="w-12 h-12 flex items-center justify-center bg-gray-800 hover:bg-yellow-400 text-white hover:text-black rounded-full transition-all duration-300 cursor-pointer"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>
        </div>

        {/* Stats */}
        <div className="grid md:grid-cols-4 gap-8 mt-16">
          <div className="text-center">
            <div className="text-4xl font-bold text-yellow-400 mb-2">200+</div>
            <div className="text-gray-400">Projects Completed</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-yellow-400 mb-2">50+</div>
            <div className="text-gray-400">Happy Clients</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-yellow-400 mb-2">5+</div>
            <div className="text-gray-400">Years Experience</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-yellow-400 mb-2">98%</div>
            <div className="text-gray-400">Client Satisfaction</div>
          </div>
        </div>
      </div>
    </section>
  );
}
